module.exports = __webpack_public_path__ + "static/media/dark-mail.6255df9a.svg";